import { setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { AttributeDefinition, AttributeInputType, AttributeTargetType, GetWBComponentByTypename } from "../Data/WBData";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import SelectField from "./SelectField";
import ButtonField from "./ButtonsField";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";




export default function MultiLocationField({label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc}:AttributeFieldProps){



    const updateFuncWrapper = (  attribute: string,
        value: string,
        targetType: AttributeTargetType
        )=>{

            if(attribute==componentAttributeTypes.multiLocation){

                if(siteData.designer){
                    const node = siteData.designer.getLayoutNodeById(layoutObject.id);
                    //reset filters for necessary components.
                    setNodeComponentAttributeValue(layoutObject,componentAttributeTypes.filters,"")
                    setNodeComponentAttributeValue(layoutObject,"classFilter","")

                    if(node){
                        node.data = null;
                    }
                }
            
        }
        updateFunc(attribute,value,AttributeTargetType.Component);

    }

    const isMultiDef:AttributeDefinition = new AttributeDefinition(componentAttributeTypes.alloWMultiLocalationBooking,"Allow Booking At",componentAttributeTypes.alloWMultiLocalationBooking,AttributeInputType.ButtonField,[

        {label:"Selected Location",value:""},
        {label:"All Locations",value:"true"}
    
    ],null,AttributeTargetType.Component);

    if(!siteData.locations || siteData.locations.length<=1){
        

        return null;
    }

    let foundPage = null;

    for(let i = 0;i<siteData.pages.length;i++){
        let page = siteData.pages[i];

        if(page.pageId == siteData.currentPageId){
            foundPage = page;
            
        }

        if(page.children)
        for(let e = 0;e<page.children.length;e++){
            if(page.children[e].pageId == siteData.currentPageId){
                foundPage = page.children[e];
                break;
            }
        }

        if(foundPage){
            break;
        }   
    }

    if(foundPage&&foundPage.isDuplicateAllLocationPage){

        return null;
    }


    const comp = GetWBComponentByTypename(layoutObject.typename);

    const bookField = comp.editList.includes(componentAttributeTypes.alloWMultiLocalationBooking);


    let optns = siteData.locations.map((location)=>{return {label:location.businessName??"unamed",value:location.encBID??"err",isDivider:(location.shopOwnerID==0)}});
    optns.unshift({label:"Current Location",value:"",isDivider:false})

    const locationDropdownDef = new AttributeDefinition(componentAttributeTypes.multiLocation,"Location Dropdown",componentAttributeTypes.multiLocation,AttributeInputType.SelectField,optns,null,AttributeTargetType.Component);

    const mLabel = layoutObject.typename===wBComponentTypeNames.businessServices||layoutObject.typename===wBComponentTypeNames.businessClass||layoutObject.typename===wBComponentTypeNames.businessBookNow?"Allow Booking for":"Allow Purchase for";
    return (
      <>
     
      <SelectField label={"Location"} allowFilter={true} definition={locationDropdownDef} layoutObject={layoutObject} updateFunc={updateFuncWrapper} screenSize={screenSize} siteData={siteData} saveFunc={saveFunc} extraClass={ bookField?"no-border":""} />
      
      { bookField &&
        <ButtonField label={mLabel} definition={isMultiDef} layoutObject={layoutObject} updateFunc={updateFuncWrapper} screenSize={screenSize} siteData={siteData} saveFunc={saveFunc} />}
      </>
    );

}